import ArgumentInputRow from '@/components/arguments/ArgumentInputRow.jsx';
import argumentSelectors from '@/redux/selectors/argumentSelectors.js';
import Panel from '@/components/panel/Panel.jsx';
import { useSelector } from 'react-redux';

const AdvancedArgumentsSection = ({ dataSource, advancedArguments, actionDefinitions, dataSourcePath = 'arguments', dataSavePath, disabled, action, simpleArguments }) => {
  const args = useSelector(argumentSelectors[dataSource].activeArguments());

  const argsWithValues = args ? Object.keys(args) : [];
  const advancedKeys = advancedArguments?.map((arg) => arg?.key);
  const hasAdvancedArgs = argsWithValues.some((n) => advancedKeys.includes(n));

  if (!advancedArguments?.length) {
    return null;
  }

  return (
    <Panel.Section collapsable={true} collapseByDefault={!hasAdvancedArgs} title={'Advanced Fields'}>
      {advancedArguments?.map((argument, idx) => (
        <ArgumentInputRow key={argument.id ? `${argument.id}-${idx}` : idx} argument={argument} definitions={actionDefinitions} definition={action} dataSource={dataSource} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} disabled={disabled} simpleArguments={simpleArguments} />
      ))}
    </Panel.Section>
  );
};

export default AdvancedArgumentsSection;
